

import React, { useContext } from "react";
import { useState, useEffect } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup, Modal, Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";
import { Context } from "../../utils/context";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import "react-phone-input-2/lib/bootstrap.css";
import { CancelButton } from "../common/Button";
import ModalSave from "../common/ModelSave";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faXmark } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

// ── Image Preview Modal ───────────────────────────────────────────────────────
const ImagePreviewModal = ({ show, onHide, imgSrc, imgName, IMG_URL }) => {
    const fullSrc = `${IMG_URL}${imgSrc}`;

    const handleDownload = async () => {
        try {
            const response = await fetch(fullSrc);
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = imgName || "image.png";
            a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            // Fallback: open in new tab if fetch fails (CORS)
            window.open(fullSrc, "_blank");
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg" className="img_preview_modal" style={{ zIndex: 99999999 }}
        >
            <Modal.Header className="border-0 pb-0">
                <Modal.Title className="fs-6 text-muted">{imgName}</Modal.Title>
                <button className="btn p-0 ms-auto" onClick={onHide}>
                    <FontAwesomeIcon icon={faXmark} size="lg" />
                </button>
            </Modal.Header>

            <Modal.Body className="text-center p-3">
                <img
                    src={fullSrc}
                    alt={imgName}
                    style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: "8px" }}
                />
            </Modal.Body>

            <Modal.Footer className="border-0 justify-content-center pt-0">
                <Button variant="primary" onClick={handleDownload}>
                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                    Download
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ImagePreviewModal;